import { ContactsApi } from '../ContactsApi/ContactsApi';
import { ForAuthorsApi } from '../ForAuthorsApi/ForAuthorsApi';
import { SbornikApi } from '../SbornikApi/SbornikApi';
class Api {
  contacts: ContactsApi;
  forAuthors: ForAuthorsApi;
  sbornik: SbornikApi;

  constructor() {
    this.contacts = new ContactsApi();
    this.forAuthors = new ForAuthorsApi();
    this.sbornik = new SbornikApi();
  }
}

export const api = new Api();
